module.exports = __webpack_public_path__ + "img/para.663b6ece.jpg";